export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV
    ? 'http://localhost:8080'
    : 'https://usacrops-api.purelinen.com.au');

export const API_ENDPOINTS = {
  BUSINESS_UNITS: `${API_BASE_URL}/business-units`,
  FARMS: `${API_BASE_URL}/farms`,
  FIELDS: `${API_BASE_URL}/fields`,
  CROPPED_FIELDS: `${API_BASE_URL}/cropped-fields`,
  CROPS: `${API_BASE_URL}/crops`,
  FIELDS_WITH_CROPS: `${API_BASE_URL}/crops/fields-with-crops`,
  BULK_UPDATE_CROPPED_FIELDS: `${API_BASE_URL}/crops/bulk-update-cropped-fields`,
  BUSINESS_YEARS: `${API_BASE_URL}/business-years`,
  AUTH: `${API_BASE_URL}/auth`,
  ORGANIZATIONS: `${API_BASE_URL}/organizations`,
  SPECIAL_USERS: `${API_BASE_URL}/special-users`,
  CARBON_INTENSITY: `${API_BASE_URL}/carbon-intensity`,
  CLEAR_CARBON_DATA: `${API_BASE_URL}/crops/clear-carbon-data`,
  FERTILIZERS: `${API_BASE_URL}/crops/fertilizers`,
  MANURES: `${API_BASE_URL}/crops/manures`,
  FERTILIZER_APPLICATIONS: `${API_BASE_URL}/crops/fertilizer-applications`,
  MANURE_APPLICATIONS: `${API_BASE_URL}/crops/manure-applications`,
  TDISC_OPERATIONS: `${API_BASE_URL}/crops/tdisc-operations`,
  TILLAGE_EVENTS: `${API_BASE_URL}/crops/tillage-events`,
  CALCULATE_EXCEL: `${API_BASE_URL}/carbon-intensity/calculate-excel`,
  CERTIFICATE: `${API_BASE_URL}/certificate`,
  // METI API endpoints
  FIELDS_METI_STATUS: `${API_BASE_URL}/fields/meti-status`,
  FIELDS_SUBMIT_ALL_TO_METI: `${API_BASE_URL}/fields/submit-all-to-meti`,
  FIELDS_SUBMIT_TO_METI: `${API_BASE_URL}/fields/submit-to-meti`,
  METI: `${API_BASE_URL}/meti`,
  // Ravah Carbon API endpoints
  RAVAH_CARBON_EXPORT: `${API_BASE_URL}/ravah-carbon/export`,
  RAVAH_CARBON_CDL_STATS: `${API_BASE_URL}/ravah-carbon/get-cdl-stats`,
} as const; 